import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { updateProductMetaData } from "@containers/App/reducer.js"
import { parseResponseData } from "../common/BookingSuccess/parser"
import { genericErrorMessage } from "./constant"

const initialState = {
    isLoading: false,
    isFetched: false,
}

/**
 * corporate lab summary page reducer
 */

export const corporateBookingSuccessPageSlice = createSlice({
    name: "corporateBookingSuccessPageReducer",
    initialState: initialState,
    reducers: {
        setSnackBarError: (state, action) => {
            state.snackBarError = action.payload
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchLabsSummaryData.fulfilled, (state, action) => {
            state.isLoading = false
            state.labsSummaryPageData = parseResponseData(action?.payload)
            state.isFetched = true
            state.error = null
        }),
            builder.addCase(fetchLabsSummaryData.pending, (state) => {
                state.isLoading = true
            }),
            builder.addCase(fetchLabsSummaryData.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
                state.snackBarError = action.payload
                state.labsSummaryPageData = null
            })
    },
})

/**
 * fetch lab summary page data
 */

export const fetchLabsSummaryData = createAsyncThunk(
    "corporateLabsBookingSuccess/fetchData",
    async (_arg, { extra, dispatch, rejectWithValue, getState }) => {
        const { api } = extra
        const { corporateDetails } = getState().shellReducer
        const { orderId, benefitId } = _arg
        try {
            if (!corporateDetails?._source) {
                throw new Error("Source is missing")
            }
            const res = await api.get(
                `/api/rbf/corporate/${corporateDetails?._source}/orders/booking?order_ids=${orderId}&benefit_id=${benefitId}`
            )
            if (res?.data?.meta_data) {
                dispatch(
                    updateProductMetaData({
                        title: res.data.meta_data?.title,
                        description: res.data.meta_data?.description,
                    })
                )
            }
            return Promise.resolve(res.data)
        } catch (err) {
            return rejectWithValue(err.message || err.error.message || genericErrorMessage)
        }
    }
)

export const { setSnackBarError } = corporateBookingSuccessPageSlice.actions

export const corporateBookingSuccessPageReducer = corporateBookingSuccessPageSlice.reducer
